<template>
  <div id="defauleMenu">
    <el-card class="box-card">
      <div slot="header" class="clearfix header">
        <span class="card-header">查询默认配置项</span>
      </div>
      <el-row>
        <el-col :span="20">
          <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
            <el-form-item label="配置项名称:" style="width: 40%;margin-right: 30px;" class="fl">
              <el-input v-model.trim="formLabelAlign.name"></el-input>
            </el-form-item>
            <el-form-item label="配置项编码:" style="width: 40%;" class="fl">
              <el-input v-model.trim="formLabelAlign.number"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4" style="margin-top: 45px;">
          <el-button type="danger" @click="clearForm()">重置</el-button>
          <el-button type="success" @click="queryFrom()">查询</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix header">
        <span class="card-header">配置项信息</span>
      </div>
      <!--列表-->
    <el-table :data="configureInfo" highlight-current-row border style="width: 100%;" 
    :header-cell-style="{'text-align':'center'}">
      <el-table-column prop="position" label="配置项位置" width="220" align="center" sortable>
      </el-table-column>
      <el-table-column prop="modular" label="配置项所在模块" width="250" sortable align="center">
      </el-table-column>
      <el-table-column prop="name" label="配置项名称" width="250" align="center" sortable>
      </el-table-column>
      <el-table-column prop="infoNumber" label="配置项编码" width="250" align="center" sortable>
      </el-table-column>
      <el-table-column label="操作" min-width="150" align="center">
        <template slot-scope="scope">
          <el-dropdown  trigger="click">
            <el-button type="primary" size="mini">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleEdit(scope.$index, scope.row)">修改</el-dropdown-item>
              <el-dropdown-item @click.native="handleDel(scope.$index, scope.row)">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination 
      layout="prev, pager, next" 
      @current-change="handleCurrentChange" 
      :page-size="20" :total="total" style="float:right;">
      </el-pagination>
    </el-col>
    <!--修改界面-->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :label-position="labelPosition" :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-form-item label="配置项位置:" prop="position" style="width: 40%;" class="fl">
            <el-input v-model.trim="editForm.position"></el-input>
          </el-form-item>
          <el-form-item label="配置项所属模块:" prop="modular" style="width: 55%;" class="fr">
            <el-input v-model.trim="editForm.modular"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="配置项名称:" prop="name" style="width: 40%;" class="fl">
            <el-input type="text" v-model.trim="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="配置项编码:" prop="infoNumber" style="width: 55%;" class="fr">
            <el-input type="text" v-model.trim="editForm.infoNumber"></el-input>
          </el-form-item>    
        </el-row>
        <el-form-item label="配置项内容:" prop="configureContact">
          <el-input type="textarea" v-model.trim="editForm.configureContact"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remarks">
          <el-input type="textarea" v-model.trim="editForm.remarks"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateData">保存</el-button>
        <el-button @click.native="dialogFormVisible=false">取消</el-button>
        <!-- <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button> -->
      </div>
    </el-dialog>
    </el-card>
  </div>
</template>
<script>

  // import Store from '../../assets/js/store/src/store'
  // import { addGood, getUnits, getCategoryTree, editGood, getGoodDetail } from '../../api/api'
  export default {
    name: 'defauleMenu',//http://192.168.1.139:8088/system/configItemMenu/list
    data () {
      return {
        labelPosition:'left',
        formLabelAlign: {
          name: '',
          number: ''
        },
        dialogTableVisible: false,
        dialogStatus: "",
        dialogFormVisible: false,
        filters: {
          name: ""
        },
        configureInfo: [
          {
            position: '实验室hi',
            modular: '租户管理',
            name: 'heihihidldkd',
            infoNumber: '11111111',
            enable: '是',
            passWord:'New@0987'
          }, 
          {
            position: '实验室hi',
            modular: '租户管理',
            name: 'heihihidldkd',
            infoNumber: '222222',
            enable: '是',
            passWord:'New@0987'
          }
        ],
        total: 0,
        page: 1,
        // listLoading: false,v-loading="listLoading"
        sels: [], //列表选中列
        passwordForm: {
          name:'',
          passWord:'New@0987'
        },
        allowForm: {
          name: '',
          remarks: '',
          tableData3: ''
        },
        allowFormRules: {
          name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        },
        editFormRules: {
          name: [{ required: true, message: "请输入配置项名称", trigger: "blur" }],
          position: [{ required: true, message: "请输入配置项位置", trigger: "blur" }],
          modular: [{ required: true, message: "请输入配置项所属模块", trigger: "blur" }],
          infoNumber: [{ required: true, message: "请输入配置项所属模块", trigger: "blur" }],
        },
      //编辑界面数据
      editForm: {
        name: "",
        position: "",
        modular: "",
        infoNumber: "",
        configureContact: "",
        remarks:''
      },
      addFormVisible: false, //新增界面是否显示
      //addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
      },
      multipleSelection: []
      }
    },
    mounted () {
        
    },
    methods: {
      //重置
      clearForm:function () {
        // body...
        this.formLabelAlign.name=''
        this.formLabelAlign.number=''
      },
       //查询
      queryFrom:function () {
        alert(111111)
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    //获取用户列表
    getUsers() {
      let para = {
        page: this.page,
        name: this.filters.name
      };
      //this.listLoading = true;
      //NProgress.start();
      getUserListPage(para).then(res => {
        this.total = res.data.total;
        // this.users = res.data.users;
        //this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel: function(index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          //this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeUser(para).then(res => {
            //this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getUsers();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.dialogFormVisible = true;
      //this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //编辑
    updateData:function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              //this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              
              editUser(para).then(res => {
                //this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                //this.editFormVisible = false;
                 this.dialogFormVisible = false;
                this.getUsers();
              });
            })
            .catch(e => {
              // 打印一下错误
              console.log(e);
            });
        }
      });
    },
    //新增
    createData: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              //this.editLoading = true;
              //NProgress.start();
              this.editForm.id = (parseInt(Math.random() * 100)).toString() // mock a id
              let para = Object.assign({}, this.editForm);
              console.log(para);
              
              addUser(para).then(res => {
                //this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.dialogFormVisible = false;
                //this.addFormVisible = false;
                this.getUsers();
              });
            })
            .catch(e => {
              // 打印一下错误
              console.log(e);
            });
        }
      });
    }
    },
    components: {
      
    }
  }
</script>
<style lang="scss" scoped>
  #defauleMenu{
    .box-card{margin-bottom: 20px;border-radius: 0px;
      /*.header{background-color: #f5f5f5}*/
      .card-header{font-size: 14px;}
    }
    
  }
</style>



// WEBPACK FOOTER //
// defaultMenu.vue?6a93c6cd